



































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  BestFriendOpenOrderApi,
  BfOpenOrderDto
} from '@eurogast/hub-client-typescript';
import { BfOrderDeserializer, BFOrderItem } from '@/services/BfOrderDeserializer';
import { ConfigService } from '@/services/ConfigService';
import { ApiService } from '@/services/ApiService';
import { CART } from '@/store/types';
import { namespace } from 'vuex-class';
import { NumberFormatter } from '@/services/NumberFormatter';
import PriceService from '@/services/PriceService';
import BestFriendOrderItem from '@/bf-order/BestFriendOrderItem.vue';
import { Big } from 'big.js';
import ConfirmationActionButton from '@/common/ConfirmationActionButton.vue';
import { Cart, CartItem } from '@/services/cart/model/cart';
import { DefaultCartApiWrapper } from '@/services/cart/api/DefaultCartApiWrapper';
import MatomoEvents from '@/matomo/events/MatomoEvents';

const cart = namespace(CART);
@Component({
  components: {ConfirmationActionButton, BestFriendOrderItem }
})
export default class BestFriendOrderItems extends Vue {

  @cart.State('cart')
  public cart: Cart;

  @Prop()
  public localOpenOrder: string;
  @Prop()
  public localOrderItems: string;
  @Prop()
  public localErrorSkus: string;

  private openOrder: BfOpenOrderDto = null;
  private orderItems: BFOrderItem[] = [];
  private opened: boolean = false;
  private bfApi = ApiService.wrap(BestFriendOpenOrderApi);
  private cartApi = DefaultCartApiWrapper.singleton();
  private errorSkus: string[] = [];

  get totalPrice() {
    if (this.orderItems.length > 0) {
      const totalPrice = this.orderItems
        .map((item) => {
          const bulkPrice = PriceService.findBestBulkPrice(item.bulkPrices, item.amount, item.unit);
          return PriceService.findFinalPrice(bulkPrice, item.amount, item.unit);
        })
        .reduce((sum, next) => next ? sum.add(next) : sum, new Big('0.0'));
      return NumberFormatter.formatPrice(totalPrice);
    }
    return '';
  }

  get errorPresent() {
    return this.openOrder.orderAddress === null || (this.errorSkus && this.errorSkus.length > 0);
  }

  get hasTotal() {
    return this.totalPrice !== '';
  }

  get companyLines() {
    return this.openOrder.orderAddress ? this.openOrder.orderAddress.companyLines.join(', ') : '';
  }

  get unloadingArea() {
    return this.openOrder.unloadingArea ? ` - ${this.openOrder.unloadingArea}` : '';
  }

  public mounted() {
    if (this.localOpenOrder) {
      this.openOrder = BfOrderDeserializer.parseBfOpenOrder(this.localOpenOrder);
    }
    if (this.localOrderItems) {
      this.orderItems = BfOrderDeserializer.parseBFOrderItems(this.localOrderItems);
    }
    if (this.localErrorSkus) {
      this.errorSkus = BfOrderDeserializer.parseBFErrorSkus(this.localErrorSkus);
    }
  }

  private toggleOpen() {
    this.opened = !this.opened;
  }

  private async deleteOpenOrder() {
    MatomoEvents.forBestfriend.deleteOpenOrder.publish();
    try {
      await this.bfApi.removeBestFriendOrder(
          ConfigService.getTenant(),
          this.openOrder.id,
          ConfigService.currentCustomerId
      );
      location.reload();
    } catch (e) {
        await ApiService.defaultErrorHandler(e);
    }
  }

  private async addOrderToCart() {
    MatomoEvents.forBestfriend.addAllProducts.publish();
    try {
      await this.cartApi.addAllItemsToOwnShoppingCart(
          ConfigService.getTenant(),
          ConfigService.currentCustomerId,
          this.getCartItems(this.orderItems)
      );
      await this.deleteOpenOrder();
    } catch (e) {
      await ApiService.defaultErrorHandler(e);
    }
  }

  private getCartItems(items: BFOrderItem[]): CartItem[] {
    return items.map((item) => this.toShoppingCartItem(item));
  }

  private toShoppingCartItem(item: BFOrderItem): CartItem {
    return CartItem.buildWithDefaults({
        sku: item.sku,
        amount: item.amount,
        unitAbbreviation: item.unitAbbr
      }
    );
  }

  get dateFormatOptions(): Intl.DateTimeFormatOptions {
    return { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
  }
}
